import React, { createContext, ReactNode, useContext } from 'react';

interface ApiProviderProps<T> {
    api: T;
    children: ReactNode;
}

const ApiContext = createContext<any>(null);

export const ApiProvider = <T,>({ api, children }: ApiProviderProps<T>): JSX.Element => (
    <ApiContext.Provider value={api}>{children}</ApiContext.Provider>
);

export const getUseApi =
    <T,>() =>
    (): T => {
        const context = useContext(ApiContext);
        if (!context) {
            throw new Error('useApi must be used within an ApiProvider');
        }
        return context as T;
    };
